import { createContext } from 'react';
import { IAuthContext } from '../interfaces/IAuthContext';

export const AuthContext = createContext<IAuthContext>({
  isInitialized: false,
  isAuthenticated: false,
  isImpersonating: false,
  isLoggingOut: false,
  user: undefined,
  loading: false,
  error: undefined,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  loginWithToken: (token: string, isImpersonating?: boolean): Promise<void> => {
    throw new Error('loginWithToken(token: string, isImpersonating?: boolean): Promise<void> not implemented');
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logout: (options?: { keepLocalData?: boolean; suppressNavigation?: boolean }): Promise<void> => {
    throw new Error('logout(): void not implemented');
  },
  getToken: (): Promise<string | null> => {
    throw new Error('getToken(): Promise<string> not implemented');
  },
});
